<template>
  <div class="outline">
    <div>
      <header class="light outline">
        <h5 class="comfortaa">Invoices</h5>
        <p>0 Unpaid Invoices</p>
      </header>
      <div class="w3-row w3-margin-bottom" ref="tableContainer">
        <template v-if="!selectedClient">
          <template v-if="state.user.invoices.total > 0">
            <table class="w3-table w3-white w3-bordered paymentMethodResults" :class="state.width > 1024 ? '' : 'w3-responsive'">
              <tr class="w3-light-grey">
                <td style="width:80px;">Invoice #</td>
                <td v-if="state.width > 600">Items</td>
                <td class="w3-center" style="width:90px;">Issued</td>
                <td class="w3-center" style="width:90px;">Due</td>
                <td class="w3-center" style="width:70px;">Total</td>
                <td class="w3-center" style="width:80px;">Status</td>
              </tr>
              <tr v-for="(invoice, index) in $options.filters.limit(state.user.invoices.list, limit)" :key="index" class="invoiceRow pointer" @click="viewInvoice(invoice)">
                <td style="white-space:nowrap">{{invoice.number}}</td>
                <td class="truncate tableItems" v-if="state.width > 600">
                  <span v-for="(item, key, i) in invoice.lines.data" :key="i">
                    {{item.description}}<span v-if="key < Object.keys(invoice.lines.data).length - 1">, </span>
                  </span>
                </td>
                <td class="w3-center roboto">{{invoice.date | date}}</td>
                <td class="w3-center roboto" v-if="invoice.due_date">{{invoice.due_date | date}}</td>
                <td class="w3-center" v-if="!invoice.due_date">-</td>
                <td class="w3-center roboto">{{invoice.total  / 100 | currency}}</td>
                <td class="w3-center" :class="{'w3-text-green': (invoice.status === 'paid'),'w3-text-red': (invoice.status === 'unpaid'),'w3-text-orange': (invoice.status === 'refunded')}">{{invoice.status | capitalize}}</td>
              </tr>
            </table>
          </template>
          <template v-else>
            <div class="w3-container w3-white">
              <p style="margin-top:15px;">No Invoices Yet</p>
            </div>
          </template>
        </template>
        <template v-if="selectedClient && selectedClient.email">
          <template v-if="state.admin.client.invoices.total > 0">
            <table class="w3-table w3-bordered paymentMethodResults w3-white">
              <tr class="w3-light-grey">
                <td class="w3-center" style="width:80px;">#</td>
                <td>Items</td>
                <td class="w3-center" style="width:90px;">Issued</td>
                <td class="w3-center" style="width:90px;">Due</td>
                <td class="w3-center" style="width:70px;">Total</td>
                <td class="w3-center" style="width:70px;">Balance</td>
                <td class="w3-center" style="width:80px;">Status</td>
              </tr>
              <tr v-for="(invoice, index) in state.admin.client.invoices.list" :key="index" class="invoiceRow" @click="viewInvoice(invoice)">
                <td class="w3-center" style="white-space:nowrap">{{invoice.number}}</td>
                <td>
                  <span v-for="(item, key, i) in invoice.lines.data" :key="i">
                    {{item.description}}<span v-if="key < Object.keys(invoice.lines.data).length - 1">, </span>
                  </span>
                </td>
                <td class="w3-center">{{invoice.date | date}}</td>
                <td class="w3-center" v-if="invoice.due_date">{{invoice.due_date | date}}</td>
                <td class="w3-center" v-if="!invoice.due_date">-</td>
                <td class="w3-center">{{invoice.total / 100 | currency}}</td>
                <td class="w3-center">{{invoice.amount_due / 100 | currency}}</td>
                <td class="w3-center" :class="{'w3-text-green': (invoice.status === 'paid'),'w3-text-red': (invoice.status === 'unpaid'),'w3-text-orange': (invoice.status === 'refunded')}">{{invoice.status | capitalize}}</td>
              </tr>
            </table>
          </template>
          <template v-else>
            <div class="w3-container w3-white">
              <p style="margin-top:15px;">No Invoices Yet</p>
            </div>
          </template>
        </template>
      </div>
    </div>
    
    <!-- <template v-if="viewDetails">
      <div class="w3-margin-bottom outline">
        <invoice-details v-on:close-invoice="viewDetails = false; $emit('viewDetails', false)" v-bind:active-invoice="activeInvoice"></invoice-details>
      </div>
    </template> -->
  </div>
</template>

<script>
const dataStore = require("../dataStore").default;
import invoiceDetailsVue from './invoiceDetails.vue';

export default {
  name: 'invoicesList',
  props: {
    selectedClient: Object,
    limit: 0
  },
  data () {
    return {
      state: dataStore.state,
      activeInvoice: dataStore.state.user.invoices.activeInvoice
    }
  },
  components: {
    'invoice-details': invoiceDetailsVue
  },
  methods: {
    viewInvoice(invoice) {
      console.log(invoice)
      this.state.user.invoices.activeInvoice = invoice
      this.$router.push('/invoices/invoiceDetails')
    }
  }
}
</script>

<style>
.w3-responsive {font-size:9pt; font-weight:500;}
td.tableItems {max-width:300px;}
</style>



// WEBPACK FOOTER //
// src/components/invoicesList.vue